import { render, staticRenderFns } from "./bv-bind-phone.vue?vue&type=template&id=e6ced238&scoped=true"
import script from "./bv-bind-phone.vue?vue&type=script&lang=js"
export * from "./bv-bind-phone.vue?vue&type=script&lang=js"
import style0 from "./bv-bind-phone.vue?vue&type=style&index=0&id=e6ced238&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../apps/gouwubao/node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ced238",
  null
  
)

export default component.exports